var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7002 0.665039H15.2998C15.8155 0.665039 16.3265 0.891854 16.7148 1.32324C16.9969 1.63661 17.193 2.03848 17.2812 2.47852C17.0053 2.59169 16.7551 2.76708 16.5508 2.99414C16.1817 3.40423 15.9854 3.9471 15.9854 4.5C15.9854 5.05037 16.1801 5.59059 16.5459 6C16.1801 6.40941 15.9854 6.94963 15.9854 7.5C15.9854 8.0529 16.1817 8.59577 16.5508 9.00586C16.7551 9.23282 17.0054 9.40732 17.2812 9.52051C17.1931 9.96091 16.9971 10.3632 16.7148 10.6768C16.3265 11.1081 15.8155 11.335 15.2998 11.335H2.7002C2.18452 11.335 1.6735 11.1081 1.28516 10.6768C1.00288 10.3631 0.805949 9.96099 0.717773 9.52051C0.993948 9.40734 1.24474 9.23305 1.44922 9.00586C1.8183 8.59577 2.01465 8.0529 2.01465 7.5C2.01465 6.94942 1.81922 6.40947 1.45312 6C1.81922 5.59053 2.01465 5.05058 2.01465 4.5C2.01465 3.9471 1.8183 3.40423 1.44922 2.99414C1.24466 2.76686 0.994085 2.59168 0.717773 2.47852C0.806043 2.03841 1.00309 1.63665 1.28516 1.32324C1.6735 0.891854 2.18452 0.665039 2.7002 0.665039Z",
    stroke: "#606060",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.99915V3.00915",
    stroke: "#606060",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.99829V6.00829",
    stroke: "#606060",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.00171V9.01171",
    stroke: "#606060",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketOutlined);
export default __webpack_public_path__ + "static/media/ticket_outlined.40b66ddc5bf8132bcae39d3ebf5f7707.svg";
export { ForwardRef as ReactComponent };